import { useMemo } from "react";

import { useGetSurveyResultsOverview } from "../../../../../../../api/hooks";
import { useSurvey } from "../../../hooks/useSurvey";

import { getCurrentPeriod } from "./utils";

interface KPIDataPoint {
	label: string[];
	value: number;
}

interface UseSurveyResultsKPIsData {
	currentPeriod: KPIDataPoint;
	participantSubmissions: KPIDataPoint;
	questionsAnswered: KPIDataPoint;
	isLoading: boolean;
}

export const useSurveyResultsKPIs = ({ surveyId }: { surveyId: string }): UseSurveyResultsKPIsData => {
	const { survey } = useSurvey({ surveyId });
	const { data: surveyResultsOverview, isLoading } = useGetSurveyResultsOverview(surveyId);

	const currentPeriod = useMemo(() => {
		if (!survey) return { label: ["Days", "Open"], value: 0 };
		return getCurrentPeriod(survey?.status, survey?.startDate, survey?.endDate);
	}, [JSON.stringify(survey)]);

	return {
		currentPeriod,
		participantSubmissions: {
			label: ["Employee", "Responses"],
			value: surveyResultsOverview?.totalResponses ?? 0,
		},
		questionsAnswered: {
			label: ["Questions", "Answered"],
			value: surveyResultsOverview?.averagePercentageOfQuestionsAnswered ?? 0,
		},
		isLoading,
	};
};
